import React from "react";
import { Navigate } from "react-router";

export const Home: React.FC = () => <Navigate to="chatroom" />;
